// // src/pages/SocialCallback.jsx
// import React, { useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { setAuthToken } from '../utils/auth';
// import { useAuth } from '../context/AuthContext';
// import baseUrl from '../components/baseUrl'

// export default function SocialCallback() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { setUser } = useAuth();
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     let token = params.get('token');

//     // fallback: some backends send token as hash (#token=...)
//     if (!token && location.hash) {
//       const hashParams = new URLSearchParams(location.hash.replace(/^#/, ''));
//       token = hashParams.get('token');
//     }

//     if (!token) {
//       navigate('/login?error=auth_failed');
//       return;
//     }

//     // store token locally
//     setAuthToken(token);

//     // verify token with backend and fetch user (optional, but recommended)
//     (async () => {
//       try {
//         console.log('Token from URL:', token);

//         const res = await fetch(`${baseUrl}/social-auth/google/verify`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ token }),
//         });

//         const data = await res.json();
//         console.log('Verification response:', data);


//         if (data.success) {
//           // backend should return user object
//           setUser(data.user || null);
//           navigate('/dashboard');
//         } else {
//           setError('Verification failed');
//           // clear token if verify failed
//           window.localStorage.removeItem('auth_token');
//           navigate('/login?error=verification_failed');
//         }
//       } catch (err) {
//         console.error('Token verification error:', err);
//         navigate('/login?error=server_error');
//       }
//     })();
//   }, [location, navigate, setUser]);

//   return (
//     <div className="min-h-screen flex items-center justify-center">
//       <div>
//         <p>Authenticating...</p>
//         {error && <p className="text-red-500">{error}</p>}
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setAuthToken } from '../utils/auth';
import { useAuth } from '../context/AuthContext';
import baseUrl from '../components/baseUrl';
import { setRawToken } from '../utils/auth'; // import both


export default function SocialCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);
  

  // Encode the data before storing it
  function encodeData(data) {
    return btoa(data); // Base64 encoding
  }


  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (!token) {
      navigate('/login?error=auth_failed');
      return;
    }

    // Save token exactly like custom login
    setRawToken(token);
    window.localStorage.setItem(
      "jdgbgiusudgfdyudbudvfudhfgbiyfudvifiudubuydfbduvuydfvuy",
      encodeData(JSON.stringify(token))
    );

    // Decode token to set user context
    try {
      const decoded = JSON.parse(atob(token.split('.')[1]));
      const userInfo = {
        user: {
          id: decoded.id,
          email: decoded.email,
          role: decoded.role,
          first_name: decoded.first_name || decoded.name?.split(' ')[0] || '',
          last_name: decoded.last_name || decoded.name?.split(' ').slice(1).join(' ') || '',
        }
      };

      setUser(userInfo.user);

      // Redirect to dashboard
      navigate('/dashboard');
    } catch (err) {
      console.error('Token decode failed', err);
      navigate('/login?error=decode_failed');
    }
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div>
        <p>Authenticating...</p>
        {error && <p className="text-red-500">{error}</p>}
      </div>
    </div>
  );
}

// useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   let token = params.get('token');

  //   // fallback: some backends send token as hash (#token=...)
  //   if (!token && location.hash) {
  //     const hashParams = new URLSearchParams(location.hash.replace(/^#/, ''));
  //     token = hashParams.get('token');
  //   }

  //   if (!token) {
  //     navigate('/login?error=auth_failed');
  //     return;
  //   }

  //   (async () => {
  //     try {
  //       // Verify token with backend
  //       const res = await fetch(`${baseUrl}/social-auth/google/verify`, {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({ token }),
  //       });

  //       const data = await res.json();

  //       if (data.success) {
  //         // store token in same key as custom login
  //         window.localStorage.setItem(
  //           "jdgbgiusudgfdyudbudvfudhfgbiyfudvifiudubuydfbduvuy",
  //           encodeData(JSON.stringify(data.token))
  //         );

  //         // set user in context
  //         setUser(data.user);

  //         // redirect to dashboard
  //         navigate('/dashboard');
  //       } else {
  //         setError('Verification failed');
  //         window.localStorage.removeItem("jdgbgiusudgfdyudbudvfudhfgbiyfudvifiudubuydfbduvuy");
  //         navigate('/login?error=verification_failed');
  //       }
  //     } catch (err) {
  //       console.error('Token verification error:', err);
  //       navigate('/login?error=server_error');
  //     }
  //   })();
  // }, [location, navigate, setUser]);
